import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				borderRadius: 6,
				padding: 10,
				marginBottom: 15,
				boxShadow: "0px 3px 29px rgba(114, 136, 128, 0.15)",
				background: theme.palette.common.white
			},
			headerPromotion: {
				display: "flex",
				justifyContent: "space-between",
				alignItems: "center",
				borderBottom: `1px solid ${theme.palette.grey[800]}`,
				paddingBottom: 10
			},
			titlePromotion: {
				display: "flex",
				alignItems: "center",
				width: "calc(100%)",
				fontSize: 16,
				fontWeight: 500,
				color: theme.palette.primary.contrastText,
				"& >img": {
					marginRight: 5
				}
			},
			mt10: {
				marginTop: 10
			},
			bodyTextDiscount: {
				display: "flex",
				justifyContent: "space-between",
				color: theme.palette.primary.contrastText,
				fontSize: 16,
				fontWeight: 500,
				marginTop: 10
			},
			threeDot: {
				overflow: "hidden",
				display: "inline-block",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				width: 250
			}
		}),
	{
		name: "PromotionOrderDetail",
		index: 1
	}
);

export default useStyles;
